import { render, staticRenderFns } from "./QNumber.vue?vue&type=template&id=c175feb8&scoped=true"
import script from "./QNumber.vue?vue&type=script&lang=js"
export * from "./QNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c175feb8",
  null
  
)

export default component.exports